import { create } from 'zustand';

interface RoleFormStore {
  selectedIds: Set<string>;
  search: string;
  debSearch: string;
  expanded: Record<string, boolean>;
  expandAll: boolean | null;
  setSearch: (q: string) => void;
  setDebSearch: (q: string) => void;
  setExpanded: (expanded: Record<string, boolean>) => void;
  setExpandAll: (v: boolean | null) => void;
  togglePermission: (id: string, selected: boolean) => void;
  toggleResource: (permIds: string[], select: boolean) => void;
  reset: () => void;
}

export const useRoleFormStore = create<RoleFormStore>((set) => ({
  selectedIds: new Set(),
  search: '',
  debSearch: '',
  expanded: {},
  expandAll: null,
  setSearch: (q) => set({ search: q }),
  setDebSearch: (q) => set({ debSearch: q }),
  setExpanded: (expanded) => set({ expanded }),
  setExpandAll: (v) => set({ expandAll: v }),
  togglePermission: (id, selected) =>
    set((s) => {
      const next = new Set(s.selectedIds);
      if (selected) next.add(id);
      else next.delete(id);
      return { selectedIds: next };
    }),
  toggleResource: (permIds, select) =>
    set((s) => {
      const next = new Set(s.selectedIds);
      permIds.forEach((id) => (select ? next.add(id) : next.delete(id)));
      return { selectedIds: next };
    }),
  reset: () =>
    set({ selectedIds: new Set(), search: '', debSearch: '', expanded: {}, expandAll: null }),
}));
